export default function dollarFilter (val: string | number) {
  const value = val || 0
  const dollar = Number(Number(value).toFixed(2))

  return dollar.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
